import { render, staticRenderFns } from "./ProductionTypes.vue?vue&type=template&id=4f402421&scoped=true&"
import script from "./ProductionTypes.vue?vue&type=script&lang=js&"
export * from "./ProductionTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f402421",
  null
  
)

export default component.exports